import { render, staticRenderFns } from "./Portfolio.vue?vue&type=template&id=10ee5391&scoped=true"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ee5391",
  null
  
)

export default component.exports